import { useState, useRef, useEffect } from 'react'
import './slider.css'
import './thumb.css'

function Slider({ percentage = 0, onChange , isPlaying}) {
  const [position, setPosition] = useState(0)
  const [marginLeft, setMarginLeft] = useState(0)
  const [progressBarWidth, setProgressBarWidth] = useState(0)

  const rangeRef = useRef()
  const thumbRef = useRef()

  useEffect(() => {
    const rangeWidth = rangeRef.current.getBoundingClientRect().width
    const thumbWidth = thumbRef.current.getBoundingClientRect().width
    const centerThumb = (thumbWidth / 100) * percentage * -1
    const centerProgressBar =
      thumbWidth + (rangeWidth / 100) * percentage - (thumbWidth / 100) * percentage
    setPosition(percentage)
    setMarginLeft(centerThumb)
    setProgressBarWidth(centerProgressBar)
  }, [percentage])

  return (
    <div className='slider-container flex-grow' dir='ltr'>
      <div
        className={`progress-bar-cover ${isPlaying?'bg-[#2B2B2B]':'bg-[#E7DB9D]'}`}
        style={{
          width: `${progressBarWidth}px`
        }}
      ></div>
      <input
        type='range'
        value={position}
        ref={rangeRef}
        step='0.01'
        className='range top-[-20px] 2xl:top-[-10px]'
        onChange={onChange}
      />
      <div
        className={`thumb ${isPlaying?'bg-[#2B2B2B]':'bg-[#E7DB9D]'}`}
        ref={thumbRef}
        style={{
          left: `${position}%`,
          marginLeft: `${marginLeft}px`
        }}
      ></div>
      
    </div>
  )
}

export default Slider;